import { CanActivateFn, Router } from '@angular/router'
import { inject } from '@angular/core'
import { AuthService } from '@core/services/auth.service'

/**
 * GuestGuard
 * - Prevents authenticated users from accessing guest pages (e.g., signin/signup)
 * - Redirects authenticated users to the default protected route
 */
export const guestGuard: CanActivateFn = () => {
  // Resolve required services at runtime
  const authService = inject(AuthService)
  const router = inject(Router)

  // If user is authenticated, prevent access to guest routes and redirect
  if (authService.isAuthenticated()) {
    return router.createUrlTree(['/platforme/dashboard'])
  }

  // Otherwise, allow access
  return true
}


